import { mainWrapper3j1n6ibqpz7ai as main } from './crowpay-apps/com/crowpay/main.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
main();

//# sourceMappingURL=crowpay-apps.mjs.map
